module.exports = __webpack_public_path__ + "static/appstore-download-49f3516372e3dbde5f541b2385745917.svg";